import * as React from 'react';
import { useTranslations } from '../../hooks/use_translations.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { getDragCancelAnnouncementEvent, getDragStartEvent, getDragEndAnnouncementEvent, getDragOverAnnouncementEvent } from './utils.js';

var useDndAnnouncements = function useDndAnnouncements(props) {
  var dragDataRef = props.dragDataRef,
    itemsPerDroppableId = props.itemsPerDroppableId,
    itemsPerDroppableIdOnDragStartRef = props.itemsPerDroppableIdOnDragStartRef,
    onDragCancel = props.onDragCancel,
    onDragEnd = props.onDragEnd,
    onDragOver = props.onDragOver,
    onDragStart = props.onDragStart;
  var _useThemeContext = useThemeContext(),
    localization = _useThemeContext.localization;
  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
    t = _useTranslations.t;
  var defaultAnnouncements = React.useMemo(function () {
    return {
      onDragStart: function onDragStart(event) {
        return t("DndContext.announcements.onDragStart", {
          itemId: event.active.id.toString()
        });
      },
      onDragOver: function onDragOver(event) {
        if (event.over) {
          return t("DndContext.announcements.onDragOverWithDroppable", {
            itemId: event.active.id.toString(),
            targetDroppableId: event.over.id.toString()
          });
        }
        return t("DndContext.announcements.onDragOverWithoutDroppable", {
          itemId: event.active.id.toString()
        });
      },
      onDragEnd: function onDragEnd(event) {
        if (event.over) {
          return t("DndContext.announcements.onDragEndWithDroppable", {
            itemId: event.active.id.toString(),
            targetDroppableId: event.over.id.toString()
          });
        }
        return t("DndContext.announcements.onDragEndWithoutDroppable", {
          itemId: event.active.id.toString()
        });
      },
      onDragCancel: function onDragCancel(event) {
        return t("DndContext.announcements.onDragCancel", {
          itemId: event.active.id.toString()
        });
      }
    };
  }, [t]);
  var onDragCancelAnnouncement = React.useCallback(function (event) {
    if (!onDragCancel) {
      return defaultAnnouncements.onDragCancel(event);
    }
    var dragCancelEvent = getDragCancelAnnouncementEvent(event.active, event.over, itemsPerDroppableIdOnDragStartRef.current, dragDataRef.current);
    return onDragCancel(dragCancelEvent);
  }, [dragDataRef, defaultAnnouncements, itemsPerDroppableIdOnDragStartRef, onDragCancel]);
  var onDragStartAnnouncement = React.useCallback(function (event) {
    if (!onDragStart) {
      return defaultAnnouncements.onDragStart(event);
    }
    var dragStartEvent = getDragStartEvent(event.active, itemsPerDroppableIdOnDragStartRef.current, dragDataRef.current);
    return onDragStart(dragStartEvent);
  }, [dragDataRef, defaultAnnouncements, itemsPerDroppableIdOnDragStartRef, onDragStart]);
  var onDragEndAnnouncement = React.useCallback(function (event) {
    if (!onDragEnd) {
      return defaultAnnouncements.onDragEnd(event);
    }
    var dragEndEvent = getDragEndAnnouncementEvent(event.active, event.over, itemsPerDroppableIdOnDragStartRef.current, dragDataRef.current);
    return onDragEnd(dragEndEvent);
  }, [dragDataRef, defaultAnnouncements, itemsPerDroppableIdOnDragStartRef, onDragEnd]);
  var onDragOverAnnouncement = React.useCallback(function (event) {
    if (!onDragOver) {
      return defaultAnnouncements.onDragOver(event);
    }
    var dragOverEvent = getDragOverAnnouncementEvent(event.active, event.over, itemsPerDroppableId, dragDataRef.current);
    return onDragOver(dragOverEvent);
  }, [dragDataRef, defaultAnnouncements, itemsPerDroppableId, onDragOver]);
  return {
    onDragCancel: onDragCancelAnnouncement,
    onDragEnd: onDragEndAnnouncement,
    onDragOver: onDragOverAnnouncement,
    onDragStart: onDragStartAnnouncement
  };
};

export { useDndAnnouncements };
